import React from 'react';
import LimitedReportWizard from '../components/monitoring-reports/limited-report/LimitedReportWizard';

const LimitedReportWizardPage = () => {
  return <LimitedReportWizard />;
};

export default LimitedReportWizardPage;
